var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('treeselect-component',_vm._g(_vm._b({class:{ 'invalid': !_vm.isValid }},'treeselect-component',{ ..._vm.$attrs, ..._vm.additionalProps },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }